export class ItemsResponse {
    limit: number;
    offset: number;
    resultCount: number;
    results?: (ItemBasicInfo)[] | null;
    sortBy: string;
    sortOrder: string;
}

export class ItemBasicInfo {
    itemId: number;
    itemName: string;
    itemTypeName: string;
    itemTypeId: number;
    itemIdentifier: string;
    itemStatus: string;
    serviceLevel: string;
}
